'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'browser';
var width = 512;
var height = 512;
var aliases = [128468];
var unicode = 'f37e';
var svgPathData = ['M16 160l104 0 376 0 0 256c0 26.5-21.5 48-48 48L64 464c-26.5 0-48-21.5-48-48l0-256z', 'M128 48l0 48 0 48 368 0 0-48c0-26.5-21.5-48-48-48L128 48zm-16 0L64 48C37.5 48 16 69.5 16 96l0 48 96 0 0-48 0-48zM16 160l0 256c0 26.5 21.5 48 48 48l384 0c26.5 0 48-21.5 48-48l0-256-376 0L16 160zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBrowser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;